"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPersonByIdResponse$ = exports.GetPersonByIdResponse$outboundSchema = exports.GetPersonByIdResponse$inboundSchema = void 0;
exports.getPersonByIdResponseToJSON = getPersonByIdResponseToJSON;
exports.getPersonByIdResponseFromJSON = getPersonByIdResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const getpersonbyidwrapper_js_1 = require("./getpersonbyidwrapper.js");
/** @internal */
exports.GetPersonByIdResponse$inboundSchema = z.object({
    data: z.array(getpersonbyidwrapper_js_1.GetPersonByIdWrapper$inboundSchema),
});
/** @internal */
exports.GetPersonByIdResponse$outboundSchema = z.object({
    data: z.array(getpersonbyidwrapper_js_1.GetPersonByIdWrapper$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPersonByIdResponse$;
(function (GetPersonByIdResponse$) {
    /** @deprecated use `GetPersonByIdResponse$inboundSchema` instead. */
    GetPersonByIdResponse$.inboundSchema = exports.GetPersonByIdResponse$inboundSchema;
    /** @deprecated use `GetPersonByIdResponse$outboundSchema` instead. */
    GetPersonByIdResponse$.outboundSchema = exports.GetPersonByIdResponse$outboundSchema;
})(GetPersonByIdResponse$ || (exports.GetPersonByIdResponse$ = GetPersonByIdResponse$ = {}));
function getPersonByIdResponseToJSON(getPersonByIdResponse) {
    return JSON.stringify(exports.GetPersonByIdResponse$outboundSchema.parse(getPersonByIdResponse));
}
function getPersonByIdResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPersonByIdResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPersonByIdResponse' from JSON`);
}
//# sourceMappingURL=getpersonbyidresponse.js.map